module.exports = __webpack_public_path__ + "img/university-of-canberra.6df975a2.png";